import iris from './iris'
export const MAX_PASSWORD_LENGTH = 64
export const MIN_PASSWORD_LENGTH = 8

export const DEFAULT_MAP_ZOOM = 15

export const MAX_IMAGE_UPLOAD_MEGABYTES = 5
export const MAX_IMAGE_UPLOAD_BYTES = MAX_IMAGE_UPLOAD_MEGABYTES * 1024 * 1024

export const MAX_VIDEO_UPLOAD_MEGABYTES = 250 
export const MAX_VIDEO_UPLOAD_BYTES = MAX_VIDEO_UPLOAD_MEGABYTES * 1024 * 1024

export const IMAGE_FORMATS = "image/png, image/jpeg, image/bmp, image/gif"
export const AUDIO_FORMATS = "audio/*"
export const VIDEO_FORMATS = "video/mp4,video/x-m4v,video/*,video/mkv,.mkv"

export const USER_ROLES = Object.freeze({
  Sponsor: iris.role + "ROLE_SPONSOR",
  Admin:  iris.role + "ROLE_ADMIN",
  Creator:  iris.role + "ROLE_CREATOR",
})

export const STORY_STATUS = Object.freeze({
  InReview: "In Review",
  Published: "Published",
  Draft: "Draft",
  Archived: "Archived",
})